(ns cms.config
  (:require 
    [firebase.core :as fb]
    [firebase.functions :as funcs]
    [cemerick.url :refer [url]]))

(defmethod fb/configuration ::fb/app [_]
  {:apiKey "AIzaSyBBIVExhGhtcZNc065_-a8PTTtqPrTOTtc"
   :authDomain  
   (let [current-url (url js/window.location)
         {:keys [protocol host port]} current-url
         auth-domain (str host)]
     (if (= "https" protocol)
       auth-domain
       "musopia-new-apps.firebaseapp.com"))
   :databaseURL "https://musopia-piano-content.firebaseio.com/"
   :projectId "musopia-new-apps"
   :storageBucket "musopia-piano-content"
   :messagingSenderId "79575471449"
   :appId "1:79575471449:web:eb1e89a8e081547d206848"
   :measurementId "G-RQ9BJJV3LQ"
   
   ;:emulator {:host "localhost" :port 5001} 
   
   })

(when-let 
  [{:keys [host port]} 
   (-> ::fb/app fb/configuration :emulator)]
  (funcs/connect-emulator host port))